import apiClient from './client';
import { ApiResponse, DashboardStats } from '@/types';

export const dashboardApi = {
  getStats: () =>
    apiClient.get<ApiResponse<DashboardStats>>('/dashboard/stats'),
};
